var React = require('react');

function CircleDoneInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"7","cy":"7","r":"7","fill":"#269C74","fillRule":"nonzero","key":0}),React.createElement("path",{"fill":"#FFF","d":"M10.15 4a.83.83 0 00-.57.247C8.273 5.543 7.079 6.813 5.822 8.081l-1.477-1.17a.833.833 0 00-1.163.128.811.811 0 00.13 1.149l2.066 1.634c.331.26.806.233 1.103-.064C7.967 8.286 9.3 6.84 10.752 5.4a.811.811 0 00.182-.903A.828.828 0 0010.15 4z","key":1})]));
}

CircleDoneInline.defaultProps = {"width":"14","height":"14"};

module.exports = CircleDoneInline;

CircleDoneInline.default = CircleDoneInline;
